module.exports = __webpack_public_path__ + "img/brushes-jp-3.a441a97.jpg";